import React from 'react';
import ProjectContent from '../components/ProjectContent';

const DownloadWebpage = () => <ProjectContent projectName='Download Webpage'/>;

export default DownloadWebpage;